import React from 'react';
import {connect} from 'react-redux';
import {deepClone, sortBy} from 'lodash';

// local imports
import {Link} from "react-router-dom";
import api from '../../../store/api'
import {toggleGlobalLoader, addErrorAlert, addLoadingAlert, removeLoadingAlert} from "../../../store/calls/alertLoadingDispatch";
import validators from "../../../utils/forms/validators";

import AdminWrapper from "../../theme/wrappers/AdminWrapper";

import Input from "../../theme/forms/Input";
import BaseForm from "../../theme/forms/BaseForm";
import PaginatedTable from "../../theme/tables/PaginatedTable";
import ConfirmModal from "../../theme/modals/ConfirmModal";
import FormModal from "../../theme/modals/FormModal";
import PacefiFullScreenSpinner from "../../theme/loaders/pacefiFullScreenSpinner";
import {getUUID} from "../../../utils/hashFuncs";
import { slugInput } from '../../../utils/forms/preconfiguredInputs';


export default class BusinessTypeAdminScreen extends React.Component {

    constructor(props) {
        super(props);

        this.state = {

            displayedData: [],
            dataPullLimit: 25,
            dataPullOffset: 0,

            // edit and delete
            editModalOpen: false,
            deleteModalOpen: false,
            editingInstance: null,
            nameFilter: null,


        }

        this.baseAPIPath = '/business-types/'

        this.createEditInputs = [
            {
                type: 'text',
                label: "Name",
                dataKey: "name",
                ...validators.isStringOfMinLength(2)
            },
            {
                type: 'text',
                label: "Name",
                dataKey: "name",
                ...validators.isStringOfMinLength(2)
            },
            {...slugInput},
            {
                type: 'description',
                label: "Description",
                dataKey: "description",
            },
            {
                type: 'checkbox',
                label: "Tax Partnership Required",
                dataKey: "tax_partnership_req",
                // value: ' ',
            },

        ]

    }

    componentDidMount() {
        toggleGlobalLoader(true);

        Promise.all([
            this.getData(),
        ])
            .then(() => toggleGlobalLoader(false))
            .catch(() => {
                addErrorAlert('Failed to load all initial data.', 10 * 1000);
                toggleGlobalLoader(false);
            })

    }

    toggleEditModal = () => {
        this.setState({editModalOpen: !this.state.editModalOpen})
    }


    getData = (xtraParams = {}) => {
        let params = {
            limit: this.state.dataPullLimit,
            offset: this.state.dataPullOffset,
            name: this.state.nameFilter,
            cacheBust: getUUID(),
            ...xtraParams
        };

        return api.get(this.baseAPIPath, params)
            .then(res => {
                this.setState({displayedData: res.data.results})
            })
    }

    handleLimitChange = (val) => {
        this.setState({dataPullLimit: val}, this.getData)
    }

    handleOffsetChange = (val) => {
        this.setState({dataPullOffset: val}, this.getData)
    }

    populateInputsWithValues = () => {

        return this.createEditInputs.map(d => {
            return {
                ...d,
                value: this.state.editingInstance ? this.state.editingInstance[d.dataKey] : null,
                disabled: !!(this.state.editingInstance?.id && d.dataKey == 'slug'),
            }
        })

    }

    handleDeleteRequest = () => {
        addLoadingAlert();
        api.patch(`${this.baseAPIPath}${this.state.editingInstance.id}/`, {is_active: 0})
            .then(() => this.getData())
            .catch(err => addErrorAlert('Failed to delete.'))
            .finally(() => this.setState({deleteModalOpen: false, editingInstance: null}, removeLoadingAlert))
    }

    handleCreateOrUpdateRequest = (data) => {
        let promise; let err_msg;
        if (this.state.editingInstance && !this.state.editingInstance.bogusKey) {
            promise = () => api.patch(`${this.baseAPIPath}${this.state.editingInstance.id}/`, data)
            err_msg = "Failed to update."
        } else {
            promise = () => api.post(this.baseAPIPath, data)
            err_msg = "Failed to create."
        }

        return promise()
            .then(() => this.getData())
            .catch(err => addErrorAlert(err_msg))
            .finally(() => this.setState({editModalOpen: false, editingInstance: null}, removeLoadingAlert))
    }

    //
    // handleSearch = (val) => {
    //     this.setState({nameFilter: val},
    //         this.getData
    //     )
    // }



    render() {
        return (
            <AdminWrapper>
                <div className="section">
                    <div className="container is-fullhd mx-6">
                        <div className="level mb-6">
                            <div className="level-left">
                                <div className="level-item">
                                    <h2 className="title is-2 is-info">Manage Business Types</h2>
                                </div>
                            </div>
                            <div className="level-right">
                                <div className="level-item">
                                    <button
                                        className='button is-link'
                                        onClick={() => this.setState({editModalOpen: true, editingInstance: {bogusKey: 1}})}
                                    >+ Create Business Type</button>
                                </div>
                            </div>
                        </div>
                        <PaginatedTable
                            className="is-fullwidth is-hoverable"
                            data={this.state.displayedData}
                            columns={['name', 'description']}
                            pullLimit={this.state.dataPullLimit}
                            handleLimitChange={this.handleLimitChange}
                            pullOffset={this.state.dataPullOffset}
                            handleOffsetChange={this.handleOffsetChange}
                            showSortBar={false}
                            actions={[
                                {
                                    name: 'Edit',
                                    elem: (<span className="icon has-text-info">
                                                <i className="fas fa-edit"/>
                                            </span>),
                                    action: (data) => this.setState({editModalOpen: true, editingInstance: {...data}})
                                },
                                {
                                    name: 'Delete',
                                    elem: (<span className="icon has-text-danger">
                                                <i className="fas fa-minus-square"/>
                                            </span>),
                                    action: (data) => this.setState({deleteModalOpen: true, editingInstance: {...data}})
                                }
                            ]}
                        />
                    </div>
                </div>

                <FormModal
                    title={this.state.editingInstance ? 'Edit ' + this.state.editingInstance.name : 'Create a new Type'}
                    visible={this.state.editModalOpen}
                    inputs={this.populateInputsWithValues()}
                    disableAutocomplete
                    onSubmit={this.handleCreateOrUpdateRequest}
                    onCancel={() => this.setState({editModalOpen: false, editingInstance: null})}
                    otherButtons={[<button className="button" onClick={() => null}>Add Another</button>]}
                />
                <ConfirmModal
                    type="warning"
                    visible={this.state.deleteModalOpen && this.state.editingInstance}
                    prompt={!!this.state.editingInstance && `Are you sure you want to deactivate type ${this.state.editingInstance.name}?`}
                    onCancel={() => this.setState({deleteModalOpen: false, editingInstance: null})}
                    onAccept={this.handleDeleteRequest}
                />

            </AdminWrapper>
        )
    }

}

